export default __webpack_public_path__ + "static/octocat-237e2214562c441f67b28f7869bac26a.png";